import { render, staticRenderFns } from "./payman-setting.vue?vue&type=template&id=23d46e51"
import script from "./payman-setting.vue?vue&type=script&lang=js"
export * from "./payman-setting.vue?vue&type=script&lang=js"
import style0 from "./payman-setting.vue?vue&type=style&index=0&id=23d46e51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports